import type React from 'react';

export const ComparisonChartIcon: React.FC = () => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="241"
    height="162"
    viewBox="0 0 241 162"
    className="inline-block"
    aria-hidden="true"
  >
    <g filter="url(#filter0_dddd_2134_10653)">
      <rect
        x="9.81152"
        y="2"
        width="224.377"
        height="132"
        rx="3.99715"
        fill="white"
      />
      <rect
        x="9.97807"
        y="2.16655"
        width="224.044"
        height="131.667"
        rx="3.8306"
        stroke="#C1D0D7"
        strokeWidth="0.333096"
      />
      <rect
        x="37.8491"
        y="12.1351"
        width="25.4236"
        height="25.4236"
        rx="5.35233"
        fill="#F3F5F8"
      />
      <rect
        x="37.8491"
        y="48.2633"
        width="25.4236"
        height="5.35233"
        rx="2.67616"
        fill="#EBEBEB"
      />
      <path
        d="M37.8504 66.8452C37.8171 66.7168 37.7173 66.6312 37.5509 66.5884L35.6964 66.2889L34.8761 64.5414C34.8048 64.394 34.6942 64.3203 34.5444 64.3203C34.3947 64.3203 34.2817 64.394 34.2056 64.5414L33.3569 66.3245L31.4952 66.6241C31.4382 66.6241 31.3859 66.6431 31.3383 66.6812C31.2908 66.7192 31.2575 66.7739 31.2385 66.8452C31.2195 66.9165 31.2171 66.9819 31.2313 67.0414C31.2456 67.1008 31.2718 67.1591 31.3098 67.2161L32.6507 68.5927L32.3155 70.5613C32.2965 70.6327 32.3012 70.7028 32.3298 70.7717C32.3583 70.8407 32.4035 70.8942 32.4653 70.9322C32.5651 71.0035 32.7007 71.0178 32.8718 70.975L34.5409 70.0406L36.217 70.975C36.2503 70.9893 36.2789 70.9988 36.3026 71.0035C36.3264 71.0083 36.3609 71.0107 36.4061 71.0107C36.4512 71.0107 36.5238 70.9845 36.6236 70.9322C36.6807 70.8942 36.7247 70.8407 36.7556 70.7717C36.7865 70.7028 36.7924 70.6327 36.7734 70.5613L36.4382 68.5927L37.772 67.2233C37.8338 67.1614 37.8706 67.102 37.8825 67.0449C37.8944 66.9879 37.8837 66.9213 37.8504 66.8452Z"
        fill="#313131"
      />
      <path
        d="M45.8536 66.8452C45.8203 66.7168 45.7205 66.6312 45.554 66.5884L43.6995 66.2889L42.8793 64.5414C42.808 64.394 42.6974 64.3203 42.5476 64.3203C42.3978 64.3203 42.2849 64.394 42.2088 64.5414L41.36 66.3245L39.4984 66.6241C39.4414 66.6241 39.3891 66.6431 39.3415 66.6812C39.294 66.7192 39.2607 66.7739 39.2416 66.8452C39.2226 66.9165 39.2202 66.9819 39.2345 67.0414C39.2488 67.1008 39.2749 67.1591 39.313 67.2161L40.6539 68.5927L40.3187 70.5613C40.2997 70.6327 40.3044 70.7028 40.3329 70.7717C40.3615 70.8407 40.4066 70.8942 40.4685 70.9322C40.5683 71.0035 40.7038 71.0178 40.875 70.975L42.5441 70.0406L44.2202 70.975C44.2535 70.9893 44.282 70.9988 44.3058 71.0035C44.3296 71.0083 44.3641 71.0107 44.4092 71.0107C44.4544 71.0107 44.5269 70.9845 44.6268 70.9322C44.6838 70.8942 44.7278 70.8407 44.7587 70.7717C44.7896 70.7028 44.7956 70.6327 44.7766 70.5613L44.4413 68.5927L45.7751 67.2233C45.837 67.1614 45.8738 67.102 45.8857 67.0449C45.8976 66.9879 45.8869 66.9213 45.8536 66.8452Z"
        fill="#313131"
      />
      <path
        d="M53.8565 66.8452C53.8232 66.7168 53.7234 66.6312 53.557 66.5884L51.7025 66.2889L50.8822 64.5414C50.8109 64.394 50.7003 64.3203 50.5505 64.3203C50.4008 64.3203 50.2878 64.394 50.2118 64.5414L49.363 66.3245L47.5013 66.6241C47.4443 66.6241 47.392 66.6431 47.3444 66.6812C47.2969 66.7192 47.2636 66.7739 47.2446 66.8452C47.2256 66.9165 47.2232 66.9819 47.2374 67.0414C47.2517 67.1008 47.2779 67.1591 47.3159 67.2161L48.6568 68.5927L48.3216 70.5613C48.3026 70.6327 48.3073 70.7028 48.3359 70.7717C48.3644 70.8407 48.4096 70.8942 48.4714 70.9322C48.5712 71.0035 48.7068 71.0178 48.8779 70.975L50.547 70.0406L52.2232 70.975C52.2564 70.9893 52.285 70.9988 52.3087 71.0035C52.3325 71.0083 52.367 71.0107 52.4122 71.0107C52.4573 71.0107 52.5299 70.9845 52.6297 70.9322C52.6868 70.8942 52.7308 70.8407 52.7617 70.7717C52.7926 70.7028 52.7985 70.6327 52.7795 70.5613L52.4443 68.5927L53.7781 67.2233C53.8399 67.1614 53.8767 67.102 53.8886 67.0449C53.9005 66.9879 53.8898 66.9213 53.8565 66.8452Z"
        fill="#313131"
      />
      <path
        d="M61.8597 66.8452C61.8264 66.7168 61.7266 66.6312 61.5601 66.5884L59.7056 66.2889L58.8854 64.5414C58.8141 64.394 58.7035 64.3203 58.5537 64.3203C58.4039 64.3203 58.291 64.394 58.2149 64.5414L57.3661 66.3245L55.5045 66.6241C55.4475 66.6241 55.3952 66.6431 55.3476 66.6812C55.3001 66.7192 55.2668 66.7739 55.2477 66.8452C55.2287 66.9165 55.2264 66.9819 55.2406 67.0414C55.2549 67.1008 55.281 67.1591 55.3191 67.2161L56.66 68.5927L56.3248 70.5613C56.3058 70.6327 56.3105 70.7028 56.339 70.7717C56.3676 70.8407 56.4127 70.8942 56.4746 70.9322C56.5744 71.0035 56.7099 71.0178 56.8811 70.975L58.5502 70.0406L60.2263 70.975C60.2596 70.9893 60.2881 70.9988 60.3119 71.0035C60.3357 71.0083 60.3702 71.0107 60.4153 71.0107C60.4605 71.0107 60.533 70.9845 60.6329 70.9322C60.6899 70.8942 60.7339 70.8407 60.7648 70.7717C60.7957 70.7028 60.8017 70.6327 60.7827 70.5613L60.4474 68.5927L61.7812 67.2233C61.8431 67.1614 61.8799 67.102 61.8918 67.0449C61.9037 66.9879 61.893 66.9213 61.8597 66.8452Z"
        fill="#313131"
      />
      <path
        d="M69.8629 66.8452C69.8296 66.7168 69.7297 66.6312 69.5633 66.5884L67.7088 66.2889L66.8886 64.5414C66.8172 64.394 66.7067 64.3203 66.5569 64.3203C66.4071 64.3203 66.2942 64.394 66.2181 64.5414L65.3693 66.3245L63.5077 66.6241C63.4506 66.6241 63.3983 66.6431 63.3508 66.6812C63.3032 66.7192 63.2699 66.7739 63.2509 66.8452C63.2319 66.9165 63.2295 66.9819 63.2438 67.0414C63.2581 67.1008 63.2842 67.1591 63.3222 67.2161L64.6632 68.5927L64.328 70.5613C64.3089 70.6327 64.3137 70.7028 64.3422 70.7717C64.3707 70.8407 64.4159 70.8942 64.4777 70.9322C64.5776 71.0035 64.7131 71.0178 64.8843 70.975L66.5533 70.0406L68.2295 70.975C68.2628 70.9893 68.2913 70.9988 68.3151 71.0035C68.3389 71.0083 68.3733 71.0107 68.4185 71.0107C68.4637 71.0107 68.5362 70.9845 68.6361 70.9322C68.6931 70.8942 68.7371 70.8407 68.768 70.7717C68.7989 70.7028 68.8049 70.6327 68.7858 70.5613L68.4506 68.5927L69.7844 67.2233C69.8462 67.1614 69.8831 67.102 69.895 67.0449C69.9069 66.9879 69.8962 66.9213 69.8629 66.8452Z"
        fill="#313131"
      />
      <line
        x1="19.9465"
        y1="79.5409"
        x2="81.1754"
        y2="79.5409"
        stroke="#87A0AB"
        strokeWidth="0.334521"
      />
      <rect
        x="19.9465"
        y="88.4058"
        width="27.4307"
        height="5.35233"
        rx="2.67616"
        fill="#EBEBEB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.0125 99.1355C26.1406 99.2637 26.1406 99.4714 26.0125 99.5996L22.8041 102.808C22.676 102.936 22.4682 102.936 22.3401 102.808L20.8818 101.35C20.7536 101.221 20.7536 101.014 20.8818 100.886C21.0099 100.757 21.2176 100.757 21.3458 100.886L22.5721 102.112L25.5484 99.1355C25.6766 99.0074 25.8843 99.0074 26.0125 99.1355Z"
        fill="#313131"
      />
      <path
        d="M32.624 101.118C32.624 99.6396 33.8222 98.4414 35.3002 98.4414H55.9479C57.4259 98.4414 58.624 99.6396 58.624 101.118C58.624 102.596 57.4259 103.794 55.9479 103.794H35.3002C33.8222 103.794 32.624 102.596 32.624 101.118Z"
        fill="#F3F5F8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.0125 109.171C26.1406 109.299 26.1406 109.507 26.0125 109.635L22.8041 112.843C22.676 112.972 22.4682 112.972 22.3401 112.843L20.8818 111.385C20.7536 111.257 20.7536 111.049 20.8818 110.921C21.0099 110.793 21.2176 110.793 21.3458 110.921L22.5721 112.147L25.5484 109.171C25.6766 109.043 25.8843 109.043 26.0125 109.171Z"
        fill="#313131"
      />
      <path
        d="M32.624 111.153C32.624 109.675 33.8222 108.477 35.3002 108.477H55.9479C57.4259 108.477 58.624 109.675 58.624 111.153C58.624 112.631 57.4259 113.829 55.9479 113.829H35.3002C33.8222 113.829 32.624 112.631 32.624 111.153Z"
        fill="#F3F5F8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.4286 119.207C25.5567 119.335 25.5567 119.543 25.4286 119.671L21.9286 123.171C21.8004 123.299 21.5927 123.299 21.4645 123.171C21.3364 123.043 21.3364 122.835 21.4645 122.707L24.9645 119.207C25.0927 119.079 25.3004 119.079 25.4286 119.207Z"
        fill="#D7D7D7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4645 119.207C21.5927 119.079 21.8004 119.079 21.9286 119.207L25.4286 122.707C25.5567 122.835 25.5567 123.043 25.4286 123.171C25.3004 123.299 25.0927 123.299 24.9645 123.171L21.4645 119.671C21.3364 119.543 21.3364 119.335 21.4645 119.207Z"
        fill="#D7D7D7"
      />
      <path
        d="M32.624 121.189C32.624 119.711 33.8222 118.513 35.3002 118.513H55.9479C57.4259 118.513 58.624 119.711 58.624 121.189C58.624 122.667 57.4259 123.865 55.9479 123.865H35.3002C33.8222 123.865 32.624 122.667 32.624 121.189Z"
        fill="#F3F5F8"
      />
      <rect
        x="109.288"
        y="12.1351"
        width="25.4236"
        height="25.4236"
        rx="5.35233"
        fill="#F3F5F8"
      />
      <rect
        x="112.633"
        y="48.2633"
        width="18.7331"
        height="5.35233"
        rx="2.67616"
        fill="#EBEBEB"
      />
      <path
        d="M109.297 66.8452C109.264 66.7168 109.164 66.6312 108.997 66.5884L107.143 66.2889L106.323 64.5414C106.251 64.394 106.141 64.3203 105.991 64.3203C105.841 64.3203 105.728 64.394 105.652 64.5414L104.803 66.3245L102.942 66.6241C102.885 66.6241 102.832 66.6431 102.785 66.6812C102.737 66.7192 102.704 66.7739 102.685 66.8452C102.666 66.9165 102.664 66.9819 102.678 67.0414C102.692 67.1008 102.718 67.1591 102.756 67.2161L104.097 68.5927L103.762 70.5613C103.743 70.6327 103.748 70.7028 103.776 70.7717C103.805 70.8407 103.85 70.8942 103.912 70.9322C104.012 71.0035 104.147 71.0178 104.318 70.975L105.987 70.0406L107.664 70.975C107.697 70.9893 107.725 70.9988 107.749 71.0035C107.773 71.0083 107.807 71.0107 107.853 71.0107C107.898 71.0107 107.97 70.9845 108.07 70.9322C108.127 70.8942 108.171 70.8407 108.202 70.7717C108.233 70.7028 108.239 70.6327 108.22 70.5613L107.885 68.5927L109.218 67.2233C109.28 67.1614 109.317 67.102 109.329 67.0449C109.341 66.9879 109.33 66.9213 109.297 66.8452Z"
        fill="#313131"
      />
      <path
        d="M117.3 66.8452C117.267 66.7168 117.167 66.6312 117.001 66.5884L115.146 66.2889L114.326 64.5414C114.254 64.394 114.144 64.3203 113.994 64.3203C113.844 64.3203 113.731 64.394 113.655 64.5414L112.807 66.3245L110.945 66.6241C110.888 66.6241 110.836 66.6431 110.788 66.6812C110.74 66.7192 110.707 66.7739 110.688 66.8452C110.669 66.9165 110.667 66.9819 110.681 67.0414C110.695 67.1008 110.721 67.1591 110.76 67.2161L112.1 68.5927L111.765 70.5613C111.746 70.6327 111.751 70.7028 111.779 70.7717C111.808 70.8407 111.853 70.8942 111.915 70.9322C112.015 71.0035 112.15 71.0178 112.322 70.975L113.991 70.0406L115.667 70.975C115.7 70.9893 115.729 70.9988 115.752 71.0035C115.776 71.0083 115.811 71.0107 115.856 71.0107C115.901 71.0107 115.973 70.9845 116.073 70.9322C116.13 70.8942 116.174 70.8407 116.205 70.7717C116.236 70.7028 116.242 70.6327 116.223 70.5613L115.888 68.5927L117.222 67.2233C117.283 67.1614 117.32 67.102 117.332 67.0449C117.344 66.9879 117.333 66.9213 117.3 66.8452Z"
        fill="#313131"
      />
      <path
        d="M125.303 66.8452C125.27 66.7168 125.17 66.6312 125.003 66.5884L123.149 66.2889L122.329 64.5414C122.257 64.394 122.147 64.3203 121.997 64.3203C121.847 64.3203 121.734 64.394 121.658 64.5414L120.81 66.3245L118.948 66.6241C118.891 66.6241 118.839 66.6431 118.791 66.6812C118.743 66.7192 118.71 66.7739 118.691 66.8452C118.672 66.9165 118.67 66.9819 118.684 67.0414C118.698 67.1008 118.724 67.1591 118.762 67.2161L120.103 68.5927L119.768 70.5613C119.749 70.6327 119.754 70.7028 119.782 70.7717C119.811 70.8407 119.856 70.8942 119.918 70.9322C120.018 71.0035 120.153 71.0178 120.324 70.975L121.994 70.0406L123.67 70.975C123.703 70.9893 123.732 70.9988 123.755 71.0035C123.779 71.0083 123.814 71.0107 123.859 71.0107C123.904 71.0107 123.976 70.9845 124.076 70.9322C124.133 70.8942 124.177 70.8407 124.208 70.7717C124.239 70.7028 124.245 70.6327 124.226 70.5613L123.891 68.5927L125.225 67.2233C125.286 67.1614 125.323 67.102 125.335 67.0449C125.347 66.9879 125.336 66.9213 125.303 66.8452Z"
        fill="#313131"
      />
      <path
        d="M133.306 66.8452C133.273 66.7168 133.173 66.6312 133.007 66.5884L131.152 66.2889L130.332 64.5414C130.261 64.394 130.15 64.3203 130 64.3203C129.85 64.3203 129.738 64.394 129.661 64.5414L128.813 66.3245L126.951 66.6241C126.894 66.6241 126.842 66.6431 126.794 66.6812C126.747 66.7192 126.713 66.7739 126.694 66.8452C126.675 66.9165 126.673 66.9819 126.687 67.0414C126.701 67.1008 126.728 67.1591 126.766 67.2161L128.107 68.5927L127.771 70.5613C127.752 70.6327 127.757 70.7028 127.786 70.7717C127.814 70.8407 127.859 70.8942 127.921 70.9322C128.021 71.0035 128.156 71.0178 128.328 70.975L129.997 70.0406L131.673 70.975C131.706 70.9893 131.735 70.9988 131.758 71.0035C131.782 71.0083 131.817 71.0107 131.862 71.0107C131.907 71.0107 131.98 70.9845 132.079 70.9322C132.136 70.8942 132.18 70.8407 132.211 70.7717C132.242 70.7028 132.248 70.6327 132.229 70.5613L131.894 68.5927L133.228 67.2233C133.29 67.1614 133.326 67.102 133.338 67.0449C133.35 66.9879 133.34 66.9213 133.306 66.8452Z"
        fill="#313131"
      />
      <path
        d="M139.831 70.9957C139.789 70.9957 139.757 70.9933 139.735 70.9886C139.714 70.9838 139.684 70.9719 139.646 70.9529L138.02 70.0329L136.351 70.9529C136.294 70.9957 136.23 71.0147 136.159 71.01C136.087 71.0052 136.016 70.9743 135.945 70.9173C135.883 70.8792 135.838 70.8257 135.809 70.7568C135.781 70.6878 135.776 70.6177 135.795 70.5464L136.13 68.5851L134.796 67.2158C134.735 67.154 134.698 67.0946 134.686 67.0375C134.674 66.9805 134.685 66.9163 134.718 66.845C134.751 66.7118 134.851 66.6239 135.017 66.5811L136.872 66.2887L137.685 64.5057C137.766 64.3821 137.879 64.3203 138.024 64.3203C138.169 64.3203 138.279 64.394 138.355 64.5414L139.168 66.3243L141.023 66.6167C141.184 66.6595 141.282 66.7475 141.315 66.8806C141.334 66.9519 141.336 67.0161 141.322 67.0732C141.308 67.1302 141.282 67.1897 141.244 67.2515L139.91 68.6208L140.245 70.5892C140.259 70.6605 140.252 70.7294 140.224 70.796C140.195 70.8626 140.152 70.9173 140.095 70.96C140.053 70.96 140 70.9648 139.938 70.9743C139.891 70.9886 139.855 70.9957 139.831 70.9957ZM138.02 69.2484C138.063 69.2484 138.096 69.2508 138.12 69.2555C138.144 69.2603 138.172 69.2722 138.205 69.2912L139.354 69.9188L139.133 68.5495C139.095 68.4354 139.13 68.3236 139.24 68.2143L140.202 67.2158L138.869 66.9876C138.812 66.9876 138.759 66.971 138.712 66.9377C138.664 66.9044 138.631 66.8592 138.612 66.8022L138.02 65.5826L137.421 66.8022C137.407 66.8545 137.376 66.8996 137.328 66.9377C137.281 66.9757 137.226 67.0066 137.164 67.0304L135.831 67.2158L136.686 68.2143C136.724 68.2476 136.86 68.2963 136.879 68.3605C136.898 68.4247 136.907 68.4877 136.907 68.5495L136.686 69.9545L137.835 69.3268C137.868 69.2936 137.896 69.2722 137.92 69.2627C137.944 69.2531 137.977 69.2484 138.02 69.2484Z"
        fill="#313131"
      />
      <line
        x1="91.3855"
        y1="79.5409"
        x2="152.614"
        y2="79.5409"
        stroke="#87A0AB"
        strokeWidth="0.334521"
      />
      <rect
        x="91.3855"
        y="88.4058"
        width="27.4307"
        height="5.35233"
        rx="2.67616"
        fill="#EBEBEB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.4514 99.1355C97.5796 99.2637 97.5796 99.4714 97.4514 99.5996L94.2431 102.808C94.1149 102.936 93.9072 102.936 93.779 102.808L92.3207 101.35C92.1926 101.221 92.1926 101.014 92.3207 100.886C92.4489 100.757 92.6566 100.757 92.7848 100.886L94.0111 102.112L96.9874 99.1355C97.1155 99.0074 97.3233 99.0074 97.4514 99.1355Z"
        fill="#313131"
      />
      <path
        d="M104.063 101.118C104.063 99.6396 105.261 98.4414 106.739 98.4414H127.387C128.865 98.4414 130.063 99.6396 130.063 101.118C130.063 102.596 128.865 103.794 127.387 103.794H106.739C105.261 103.794 104.063 102.596 104.063 101.118Z"
        fill="#F3F5F8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.8675 109.171C96.9957 109.299 96.9957 109.507 96.8675 109.635L93.3675 113.135C93.2394 113.263 93.0316 113.263 92.9035 113.135C92.7753 113.007 92.7753 112.799 92.9035 112.671L96.4035 109.171C96.5316 109.043 96.7394 109.043 96.8675 109.171Z"
        fill="#D7D7D7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.9035 109.171C93.0316 109.043 93.2394 109.043 93.3675 109.171L96.8675 112.671C96.9957 112.799 96.9957 113.007 96.8675 113.135C96.7394 113.263 96.5316 113.263 96.4035 113.135L92.9035 109.635C92.7753 109.507 92.7753 109.299 92.9035 109.171Z"
        fill="#D7D7D7"
      />
      <path
        d="M104.063 111.153C104.063 109.675 105.261 108.477 106.739 108.477H127.387C128.865 108.477 130.063 109.675 130.063 111.153C130.063 112.631 128.865 113.829 127.387 113.829H106.739C105.261 113.829 104.063 112.631 104.063 111.153Z"
        fill="#F3F5F8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.8675 119.207C96.9957 119.335 96.9957 119.543 96.8675 119.671L93.3675 123.171C93.2394 123.299 93.0316 123.299 92.9035 123.171C92.7753 123.043 92.7753 122.835 92.9035 122.707L96.4035 119.207C96.5316 119.079 96.7394 119.079 96.8675 119.207Z"
        fill="#D7D7D7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.9035 119.207C93.0316 119.079 93.2394 119.079 93.3675 119.207L96.8675 122.707C96.9957 122.835 96.9957 123.043 96.8675 123.171C96.7394 123.299 96.5316 123.299 96.4035 123.171L92.9035 119.671C92.7753 119.543 92.7753 119.335 92.9035 119.207Z"
        fill="#D7D7D7"
      />
      <path
        d="M104.063 121.189C104.063 119.711 105.261 118.513 106.739 118.513H127.387C128.865 118.513 130.063 119.711 130.063 121.189C130.063 122.667 128.865 123.865 127.387 123.865H106.739C105.261 123.865 104.063 122.667 104.063 121.189Z"
        fill="#F3F5F8"
      />
      <rect
        x="180.727"
        y="12.1351"
        width="25.4236"
        height="25.4236"
        rx="5.35233"
        fill="#F3F5F8"
      />
      <rect
        x="176.378"
        y="48.2633"
        width="34.1211"
        height="5.35233"
        rx="2.67616"
        fill="#EBEBEB"
      />
      <path
        d="M180.728 66.8452C180.695 66.7168 180.595 66.6312 180.429 66.5884L178.574 66.2889L177.754 64.5414C177.683 64.394 177.572 64.3203 177.422 64.3203C177.273 64.3203 177.16 64.394 177.084 64.5414L176.235 66.3245L174.373 66.6241C174.316 66.6241 174.264 66.6431 174.216 66.6812C174.169 66.7192 174.135 66.7739 174.116 66.8452C174.097 66.9165 174.095 66.9819 174.109 67.0414C174.124 67.1008 174.15 67.1591 174.188 67.2161L175.529 68.5927L175.193 70.5613C175.174 70.6327 175.179 70.7028 175.208 70.7717C175.236 70.8407 175.281 70.8942 175.343 70.9322C175.443 71.0035 175.579 71.0178 175.75 70.975L177.419 70.0406L179.095 70.975C179.128 70.9893 179.157 70.9988 179.181 71.0035C179.204 71.0083 179.239 71.0107 179.284 71.0107C179.329 71.0107 179.402 70.9845 179.502 70.9322C179.559 70.8942 179.603 70.8407 179.633 70.7717C179.664 70.7028 179.67 70.6327 179.651 70.5613L179.316 68.5927L180.65 67.2233C180.712 67.1614 180.749 67.102 180.76 67.0449C180.772 66.9879 180.762 66.9213 180.728 66.8452Z"
        fill="#313131"
      />
      <path
        d="M188.732 66.8452C188.698 66.7168 188.598 66.6312 188.432 66.5884L186.577 66.2889L185.757 64.5414C185.686 64.394 185.575 64.3203 185.426 64.3203C185.276 64.3203 185.163 64.394 185.087 64.5414L184.238 66.3245L182.376 66.6241C182.319 66.6241 182.267 66.6431 182.219 66.6812C182.172 66.7192 182.139 66.7739 182.12 66.8452C182.101 66.9165 182.098 66.9819 182.112 67.0414C182.127 67.1008 182.153 67.1591 182.191 67.2161L183.532 68.5927L183.197 70.5613C183.178 70.6327 183.182 70.7028 183.211 70.7717C183.239 70.8407 183.285 70.8942 183.346 70.9322C183.446 71.0035 183.582 71.0178 183.753 70.975L185.422 70.0406L187.098 70.975C187.131 70.9893 187.16 70.9988 187.184 71.0035C187.208 71.0083 187.242 71.0107 187.287 71.0107C187.332 71.0107 187.405 70.9845 187.505 70.9322C187.562 70.8942 187.606 70.8407 187.637 70.7717C187.668 70.7028 187.674 70.6327 187.654 70.5613L187.319 68.5927L188.653 67.2233C188.715 67.1614 188.752 67.102 188.764 67.0449C188.776 66.9879 188.765 66.9213 188.732 66.8452Z"
        fill="#313131"
      />
      <path
        d="M196.734 66.8452C196.701 66.7168 196.601 66.6312 196.435 66.5884L194.58 66.2889L193.76 64.5414C193.689 64.394 193.578 64.3203 193.428 64.3203C193.279 64.3203 193.166 64.394 193.09 64.5414L192.241 66.3245L190.379 66.6241C190.322 66.6241 190.27 66.6431 190.222 66.6812C190.175 66.7192 190.142 66.7739 190.123 66.8452C190.103 66.9165 190.101 66.9819 190.115 67.0414C190.13 67.1008 190.156 67.1591 190.194 67.2161L191.535 68.5927L191.2 70.5613C191.181 70.6327 191.185 70.7028 191.214 70.7717C191.242 70.8407 191.288 70.8942 191.349 70.9322C191.449 71.0035 191.585 71.0178 191.756 70.975L193.425 70.0406L195.101 70.975C195.134 70.9893 195.163 70.9988 195.187 71.0035C195.21 71.0083 195.245 71.0107 195.29 71.0107C195.335 71.0107 195.408 70.9845 195.508 70.9322C195.565 70.8942 195.609 70.8407 195.64 70.7717C195.671 70.7028 195.676 70.6327 195.657 70.5613L195.322 68.5927L196.656 67.2233C196.718 67.1614 196.755 67.102 196.767 67.0449C196.778 66.9879 196.768 66.9213 196.734 66.8452Z"
        fill="#313131"
      />
      <path
        d="M204.738 66.8452C204.704 66.7168 204.604 66.6312 204.438 66.5884L202.584 66.2889L201.763 64.5414C201.692 64.394 201.581 64.3203 201.432 64.3203C201.282 64.3203 201.169 64.394 201.093 64.5414L200.244 66.3245L198.382 66.6241C198.325 66.6241 198.273 66.6431 198.226 66.6812C198.178 66.7192 198.145 66.7739 198.126 66.8452C198.107 66.9165 198.104 66.9819 198.119 67.0414C198.133 67.1008 198.159 67.1591 198.197 67.2161L199.538 68.5927L199.203 70.5613C199.184 70.6327 199.188 70.7028 199.217 70.7717C199.246 70.8407 199.291 70.8942 199.352 70.9322C199.452 71.0035 199.588 71.0178 199.759 70.975L201.428 70.0406L203.104 70.975C203.138 70.9893 203.166 70.9988 203.19 71.0035C203.214 71.0083 203.248 71.0107 203.293 71.0107C203.338 71.0107 203.411 70.9845 203.511 70.9322C203.568 70.8942 203.612 70.8407 203.643 70.7717C203.674 70.7028 203.68 70.6327 203.661 70.5613L203.325 68.5927L204.659 67.2233C204.721 67.1614 204.758 67.102 204.77 67.0449C204.782 66.9879 204.771 66.9213 204.738 66.8452Z"
        fill="#313131"
      />
      <path
        d="M212.741 66.8452C212.708 66.7168 212.608 66.6312 212.441 66.5884L210.587 66.2889L209.766 64.5414C209.695 64.394 209.585 64.3203 209.435 64.3203C209.285 64.3203 209.172 64.394 209.096 64.5414L208.247 66.3245L206.386 66.6241C206.329 66.6241 206.276 66.6431 206.229 66.6812C206.181 66.7192 206.148 66.7739 206.129 66.8452C206.11 66.9165 206.107 66.9819 206.122 67.0414C206.136 67.1008 206.162 67.1591 206.2 67.2161L207.541 68.5927L207.206 70.5613C207.187 70.6327 207.192 70.7028 207.22 70.7717C207.249 70.8407 207.294 70.8942 207.356 70.9322C207.456 71.0035 207.591 71.0178 207.762 70.975L209.431 70.0406L211.107 70.975C211.141 70.9893 211.169 70.9988 211.193 71.0035C211.217 71.0083 211.251 71.0107 211.296 71.0107C211.342 71.0107 211.414 70.9845 211.514 70.9322C211.571 70.8942 211.615 70.8407 211.646 70.7717C211.677 70.7028 211.683 70.6327 211.664 70.5613L211.329 68.5927L212.662 67.2233C212.724 67.1614 212.761 67.102 212.773 67.0449C212.785 66.9879 212.774 66.9213 212.741 66.8452Z"
        fill="#313131"
      />
      <line
        x1="162.824"
        y1="79.5409"
        x2="224.053"
        y2="79.5409"
        stroke="#87A0AB"
        strokeWidth="0.334521"
      />
      <rect
        x="162.824"
        y="88.4058"
        width="27.4307"
        height="5.35233"
        rx="2.67616"
        fill="#EBEBEB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M168.89 99.1355C169.019 99.2637 169.019 99.4714 168.89 99.5996L165.682 102.808C165.554 102.936 165.346 102.936 165.218 102.808L163.76 101.35C163.632 101.221 163.632 101.014 163.76 100.886C163.888 100.757 164.096 100.757 164.224 100.886L165.45 102.112L168.426 99.1355C168.554 99.0074 168.762 99.0074 168.89 99.1355Z"
        fill="#313131"
      />
      <path
        d="M175.502 101.118C175.502 99.6396 176.7 98.4414 178.178 98.4414H198.826C200.304 98.4414 201.502 99.6396 201.502 101.118C201.502 102.596 200.304 103.794 198.826 103.794H178.178C176.7 103.794 175.502 102.596 175.502 101.118Z"
        fill="#F3F5F8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M168.89 109.171C169.019 109.299 169.019 109.507 168.89 109.635L165.682 112.843C165.554 112.972 165.346 112.972 165.218 112.843L163.76 111.385C163.632 111.257 163.632 111.049 163.76 110.921C163.888 110.793 164.096 110.793 164.224 110.921L165.45 112.147L168.426 109.171C168.554 109.043 168.762 109.043 168.89 109.171Z"
        fill="#313131"
      />
      <path
        d="M175.502 111.153C175.502 109.675 176.7 108.477 178.178 108.477H198.826C200.304 108.477 201.502 109.675 201.502 111.153C201.502 112.631 200.304 113.829 198.826 113.829H178.178C176.7 113.829 175.502 112.631 175.502 111.153Z"
        fill="#F3F5F8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M168.89 119.207C169.019 119.335 169.019 119.543 168.89 119.671L165.682 122.879C165.554 123.007 165.346 123.007 165.218 122.879L163.76 121.421C163.632 121.293 163.632 121.085 163.76 120.957C163.888 120.829 164.096 120.829 164.224 120.957L165.45 122.183L168.426 119.207C168.554 119.079 168.762 119.079 168.89 119.207Z"
        fill="#313131"
      />
      <path
        d="M175.502 121.189C175.502 119.711 176.7 118.513 178.178 118.513H198.826C200.304 118.513 201.502 119.711 201.502 121.189C201.502 122.667 200.304 123.865 198.826 123.865H178.178C176.7 123.865 175.502 122.667 175.502 121.189Z"
        fill="#F3F5F8"
      />
    </g>
    <defs>
      <filter
        id="filter0_dddd_2134_10653"
        x="0.480799"
        y="0.377265"
        width="239.793"
        height="160.804"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.21705" />
        <feGaussianBlur stdDeviation="1.41989" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.721569 0 0 0 0 0.721569 0 0 0 0 0.721569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2134_10653"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.405684" dy="4.8682" />
        <feGaussianBlur stdDeviation="2.4341" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.721569 0 0 0 0 0.721569 0 0 0 0 0.721569 0 0 0 0.09 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_2134_10653"
          result="effect2_dropShadow_2134_10653"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.811367" dy="10.9535" />
        <feGaussianBlur stdDeviation="3.24547" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.721569 0 0 0 0 0.721569 0 0 0 0 0.721569 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_2134_10653"
          result="effect3_dropShadow_2134_10653"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1.62273" dy="19.4728" />
        <feGaussianBlur stdDeviation="3.85399" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.721569 0 0 0 0 0.721569 0 0 0 0 0.721569 0 0 0 0.01 0"
        />
        <feBlend
          mode="normal"
          in2="effect3_dropShadow_2134_10653"
          result="effect4_dropShadow_2134_10653"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect4_dropShadow_2134_10653"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
